import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-075e40c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "air-status-detail" }
const _hoisted_2 = { class: "status-container" }
const _hoisted_3 = { class: "expression" }
const _hoisted_4 = { class: "aqi-value" }
const _hoisted_5 = { class: "value-txt" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name-txt" }, "AQI指数", -1))
const _hoisted_7 = { class: "factor-value" }
const _hoisted_8 = { class: "prompt-language" }
const _hoisted_9 = { class: "factor-txt" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "value-txt" }, "首要污染物: ", -1))
const _hoisted_11 = { class: "name-txt" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pul-title" }, [
  /*#__PURE__*/_createTextVNode("PM"),
  /*#__PURE__*/_createElementVNode("sub", null, "2.5")
], -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "value-text" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" μg/m")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pul-title" }, [
  /*#__PURE__*/_createTextVNode(" PM"),
  /*#__PURE__*/_createElementVNode("sub", null, "10")
], -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "value-text" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" μg/m")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pul-title" }, [
  /*#__PURE__*/_createTextVNode("SO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1))
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "value-text" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" μg/m")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pul-title" }, [
  /*#__PURE__*/_createTextVNode("NO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1))
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "value-text" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" μg/m")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pul-title" }, [
  /*#__PURE__*/_createTextVNode("O"),
  /*#__PURE__*/_createElementVNode("sub", null, "3")
], -1))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "value-text" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" μg/m")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pul-title" }, "CO", -1))
const _hoisted_38 = { class: "value" }
const _hoisted_39 = { class: "value-text" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" mg/m")
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))

import { Progress, } from 'ant-design-vue';
import { useStore, } from 'vuex';
import {
  computed, watch, onMounted,ref,
} from 'vue';
import qs from 'qs';

import {
  factorColorRender,
  factorEmoRender,
  fontColorRender,
  factorColorOpacity01,
  getAqiSuggestion,
} from '@/utils/index';

interface AirStatusData {
  [propName: string]: any;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const airStatusData = ref<AirStatusData>({});

const frameData = computed(() => store.state.gateway.frameData);
const regionId = computed(() => store.state.OLMap.regionId) || 320100000000;

const selectCityId = computed(() => store.state.airStatus.selectCityId);

const isAqi = computed(() => airStatusData.value && airStatusData.value.aqi && airStatusData.value.aqi !== '-9999');

// 要素对应文字
const factorKey = {
  AQI: 'AQI',
  PM25: 'PM₂.₅',
  PM10: 'PM₁₀',
  SO2: 'SO₂',
  NO2: 'NO₂',
  CO: 'CO',
  O3: 'O₃',
};

const firstPollution: any = ref();

const getFirstPollution = () => {
  let temp = [];

  if (airStatusData.value.pollutant?.includes(',') || airStatusData.value.firstPollution?.includes(',')) {
    temp = airStatusData.value.pollutant?.split(',') || airStatusData.value.firstPollution?.split(',');
    firstPollution.value = temp.map((i: string) => factorKey[i]).join();
  } else if (airStatusData.value.pollutant || airStatusData.value.firstPollution) {
    temp = [factorKey[airStatusData.value.pollutant] || factorKey[airStatusData.value.firstPollution],];
    firstPollution.value = temp.join();
  } else {
    firstPollution.value = '--';
  }
};

// 当前站点信息
const pointInfo = computed(() => store.state.airStatus.pointInfo);

watch(frameData, (cur) => {
  airStatusData.value = cur;
  getFirstPollution();
});

watch(pointInfo, (cur) => {
  airStatusData.value = cur;
  getFirstPollution();
});

watch(regionId, (cur) => {
  if (cur) {
    store.dispatch('gateway/getAirFrameData', { regionId: cur, });
  }
});

watch(selectCityId, (cur) => {
  if (cur) {
    store.commit('airStatus/setPointInfo', {});
    store.dispatch('gateway/getAirFrameData', { regionId: cur, });
  }
});

onMounted(() => {
  if (regionId.value) {
    const param = {
      regionId: regionId.value,
    };

    store.dispatch('gateway/getAirFrameData', param);
  }
});

/**
 * @todo 后端无数据处理
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card-top",
        style: _normalizeStyle({
        backgroundColor: _unref(isAqi) ? _unref(factorColorRender)(Number(airStatusData.value.aqi), 'aqi') : _unref(factorColorRender)(-9999, 'aqi') ,
        color: _unref(fontColorRender)(Number(airStatusData.value.aqi), 'aqi'),
      })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: _normalizeClass(["iconfont", _unref(isAqi) ? `icon-emo-${_unref(factorEmoRender)(Number(airStatusData.value.aqi), 'aqi')}` : 'icon-emo-mild'])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(isAqi) ? Number(airStatusData.value.aqi).toFixed(0) :'--'), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(isAqi) ? _unref(getAqiSuggestion)(Number(airStatusData.value.aqi)) : '--'), 1),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(firstPollution.value), 1)
          ])
        ])
      ], 4),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _hoisted_12,
          _createVNode(_unref(Progress), {
            class: "progress",
            percent: airStatusData.value.pm25 / 5,
            showInfo: false,
            strokeWidth: 10,
            strokeColor: _unref(factorColorRender)(Number(airStatusData.value.pm25), 'pm25'),
            trailColor: _unref(factorColorOpacity01)(Number(airStatusData.value.pm25), 'pm25')
          }, null, 8, ["percent", "strokeColor", "trailColor"]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(airStatusData.value.pm25 === '-9999' ? '-' : airStatusData.value.pm25), 1),
            _hoisted_15,
            _hoisted_16
          ])
        ]),
        _createElementVNode("li", null, [
          _hoisted_17,
          _createVNode(_unref(Progress), {
            class: "progress",
            percent: airStatusData.value.pm10 / 6,
            showInfo: false,
            strokeWidth: 10,
            strokeColor: _unref(factorColorRender)(Number(airStatusData.value.pm10), 'pm10'),
            trailColor: _unref(factorColorOpacity01)(Number(airStatusData.value.pm10), 'pm10')
          }, null, 8, ["percent", "strokeColor", "trailColor"]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(airStatusData.value.pm10 === '-9999' ? '-' : airStatusData.value.pm10), 1),
            _hoisted_20,
            _hoisted_21
          ])
        ]),
        _createElementVNode("li", null, [
          _hoisted_22,
          _createVNode(_unref(Progress), {
            class: "progress",
            percent: airStatusData.value.so2 / 26.2,
            showInfo: false,
            strokeWidth: 10,
            strokeColor: _unref(factorColorRender)(Number(airStatusData.value.so2), 'so2'),
            trailColor: _unref(factorColorOpacity01)(Number(airStatusData.value.so2), 'so2')
          }, null, 8, ["percent", "strokeColor", "trailColor"]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(airStatusData.value.so2 === '-9999' ? '-' : airStatusData.value.so2), 1),
            _hoisted_25,
            _hoisted_26
          ])
        ]),
        _createElementVNode("li", null, [
          _hoisted_27,
          _createVNode(_unref(Progress), {
            class: "progress",
            percent: airStatusData.value.no2 / 9.4,
            showInfo: false,
            strokeWidth: 10,
            strokeColor: _unref(factorColorRender)(Number(airStatusData.value.no2), 'no2'),
            trailColor: _unref(factorColorOpacity01)(Number(airStatusData.value.no2), 'no2')
          }, null, 8, ["percent", "strokeColor", "trailColor"]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, _toDisplayString(airStatusData.value.no2 === '-9999' ? '-' : airStatusData.value.no2), 1),
            _hoisted_30,
            _hoisted_31
          ])
        ]),
        _createElementVNode("li", null, [
          _hoisted_32,
          _createVNode(_unref(Progress), {
            class: "progress",
            percent: airStatusData.value.o3 / 8,
            showInfo: false,
            strokeWidth: 10,
            strokeColor: _unref(factorColorRender)(Number(airStatusData.value.o3), 'o3'),
            trailColor: _unref(factorColorOpacity01)(Number(airStatusData.value.o3), 'o3')
          }, null, 8, ["percent", "strokeColor", "trailColor"]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("span", _hoisted_34, _toDisplayString(airStatusData.value.o3 === '-9999' ? '-' : airStatusData.value.o3), 1),
            _hoisted_35,
            _hoisted_36
          ])
        ]),
        _createElementVNode("li", null, [
          _hoisted_37,
          _createVNode(_unref(Progress), {
            class: "progress",
            percent: airStatusData.value.co / 0.6,
            showInfo: false,
            strokeWidth: 10,
            strokeColor: _unref(factorColorRender)(Number(airStatusData.value.co), 'co'),
            trailColor: _unref(factorColorOpacity01)(Number(airStatusData.value.co), 'co')
          }, null, 8, ["percent", "strokeColor", "trailColor"]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("span", _hoisted_39, _toDisplayString(airStatusData.value.co === '-9999' ? '-' : airStatusData.value.co), 1),
            _hoisted_40,
            _hoisted_41
          ])
        ])
      ])
    ])
  ]))
}
}

})